
import {BitrixVue} from 'ui.vue3';
import {Dom, Loc} from 'main.core';
// import {VuexBuilder} from "ui.vue.vuex";
import {ApplicationModel} from './component/model';

import {CalcComponent} from './component/decor-calc';

export class DecorCalc
{
	#application;

    constructor(rootNode): void
	{
		const context = this;

		this.rootNode = document.querySelector(rootNode);
        
        // this.initStore()
		// 	.then(result => this.initComponent(result))
		// 	.then(result => this.initTemplate(result))
		// ;

        BitrixVue.createApp({
			name: 'DecorCalc',
			components: {
                CalcComponent		
            },
			beforeCreate(): void
			{
				this.$bitrix.Application.set(context);
			},
			template: '<CalcComponent/>'
		}).mount(this.rootNode);
	}
}
